/* eslint-disable no-restricted-syntax,guard-for-in */
import _ from "lodash";

const compareRoles = (userRoles, menuRoles) => {
    if (!menuRoles.length) {
        return true;
    } else if (_.intersectionWith(userRoles, menuRoles, _.isEqual).length) {
        return true;
    }
    return false;
};

const checkUserPermission = (menuItems, currentUrl, userRole, returnAsMenuItem = false) => {
    if (currentUrl === "/") {
        return true;
    }
    let currentMenu = false;
    for (const index in menuItems) {
        if (menuItems[index].url !== "/") {
            if (menuItems[index].url !== "" && currentUrl.includes(menuItems[index].url)) {
                currentMenu = menuItems[index];
                if (returnAsMenuItem) {
                    return currentMenu;
                }
                break;
            } else if (
                compareRoles(userRole, menuItems[index].permission) &&
                menuItems[index].menu.length
            ) {
                currentMenu = checkUserPermission(
                    menuItems[index].menu,
                    currentUrl,
                    userRole,
                    true
                );

                if (currentMenu !== false) {
                    break;
                }
            }
        }
    }

    if (currentMenu === false) {
        return false;
    }

    return compareRoles(userRole, currentMenu.permission);
};

export default checkUserPermission;



// WEBPACK FOOTER //
// ./src/helpers/check-user-permission.js